'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { setSentryTag, clearSentryTag } from '@/modules/sentry/sentry.utils';
import type { Subsidiary } from '@/modules/subsidiary';
type SentrySubsidiaryProviderProps = {
  subsidiary?: Subsidiary;
};

/**
 * 🏪 Subsidiary-level Sentry tags registry
 * Sets subsidiary tags for error tracking using flat naming with underscores
 * Only clears subsidiary tags on unmount (isolation)
 */
export default function SentrySubsidiaryContext(t0) {
  const $ = _c(3);
  const {
    subsidiary
  } = t0;
  let t1;
  let t2;
  if ($[0] !== subsidiary) {
    t1 = () => {
      if (subsidiary) {
        setSentryTag("subsidiary_id", subsidiary.id);
        setSentryTag("subsidiary_name", subsidiary.company_name);
      }
      return () => {
        if (subsidiary) {
          clearSentryTag("subsidiary_id");
          clearSentryTag("subsidiary_name");
        }
      };
    };
    t2 = [subsidiary];
    $[0] = subsidiary;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return null;
}